import React, { Component } from 'react'
import { connect } from 'react-redux';
import _ from 'lodash';
import { Icon, Row, Col, Spin, Pagination, message, Tooltip } from 'antd';
import moment from 'moment'
import Modal from 'react-modal';
import Truncate from 'react-truncate-dom'
import { setCollection, deleteCollection } from 'modules/collection/actions';
import { toggleArticleModal, fetchMltData, fetchComment, setArticle } from '../actions'
import { Scrollbars } from 'react-custom-scrollbars';
import * as notification from '../../notification';
const avatarUrl = require('modules/feed/components/images/avatar.png');
import { logAsync } from 'helpers/elogAsync';
import config from 'config';
import mediaElement from 'mediaelement';
import './style.css';
import "node_modules/video-react/dist/video-react.css";
import { Player } from 'video-react';
import jwPlayerSWF from '@jarvisaoieong/jwplayer/player.swf';
import { flashmediaelement } from 'mediaelement/build/flashmediaelement.swf';
import { silverlightmediaelement } from 'mediaelement/build/silverlightmediaelement.xap'
const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.65)',
    zIndex: '999',
  },
  content: {
    position: 'absolute',
    top: '30px',
    left: '15%',
    right: '15%',
    bottom: '30px',
    overflowX: 'hidden',
    border: '1px solid #fff',
    background: '#fff',
    overflow: 'auto',
    WebkitOverflowScrolling: 'touch',
    borderRadius: '7px',
    outline: 'none',
    padding: '0px',
    zIndex: '999',
  }
};

const container = connect(
  (state) => ({
    articleModal: _.get(state, 'modal.articleModal'),
    clipping: _.get(state, 'collection.globalIds', []),
    permission: _.get(state, 'me.permission.favoriteQuota'),
    userId: _.get(state, 'me.id'),
    loadingList: _.get(state, 'collection.loadingList'),
  })
)

class ArticleModal extends Component {

  state = {
    current: 1
  }

  componentDidUpdate(prevProps, prevState) {
    const { articleModal } = this.props;
    if (!_.isEmpty(articleModal.data)) {
      if (articleModal.data.mediaType == 'video') {
        if (!_.isEmpty(this.refs.video)) {
          this.renderVideo();
        }
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      dispatch,
      articleModal
    } = nextProps;
    const comments = ['forum', 'facebook', 'goods', 'page']
    if (!_.isEqual(this.props.articleModal.data, articleModal.data)) {
      if (!_.isEmpty(articleModal.data.globalId)) {
        if (_.includes(comments, articleModal.data.mediaType)) {
          dispatch(fetchComment({
            globalId: articleModal.data.globalId,
            limit: 5
          }))
            .then(() => {
              dispatch(fetchMltData({
                globalId: articleModal.data.globalId,
                limit: 10
              }))
            })
        } else {
          dispatch(fetchMltData({
            globalId: articleModal.data.globalId,
            limit: 10
          }))
        }
      }
    }
  }

  matchTDM(data) {
    return _.get(data, 'videoUrl', '').match(/tdm\.com/);
  }

  renderVideo() {
    const { data } = this.props.articleModal;
    if (this.matchTDM(data)) {
      const [memo, path, file] = data.videoUrl.match(/@cnews\/(.+)\/mp4:(.+)$/);
      jwplayer('video').setup({
        flashplayer: jwPlayerSWF,
        streamer: 'rtmp://vod1.tdm.com.mo:80/cnews/_definst_/',
        file: `mp4:${path}/${file}`,
        image: `http://www.tdm.com.mo/news/cnews/${path}/${file.replace('.mp4', '_1.jpg')}`,
        width: 550,
        height: 360,
      });
    } else {
      mediaElement(this.refs.video, {
        flashName: flashmediaelement,
        silverlightName: silverlightmediaelement,
      });
    }
  }

  onPageChange = (current) => {
    const {
      dispatch,
      articleModal
    } = this.props;
    this.setState({
      current: current
    })
    dispatch(fetchComment({
      globalId: articleModal.data.globalId,
      limit: 5,
      offset: (current - 1) * 5,
    }))
  };

  handleModalState = (data) => {
    const {
      dispatch
    } = this.props;
    dispatch(toggleArticleModal(data));
  };

  handleClickData = (data) => {
    const {
      dispatch
    } = this.props;
    dispatch(setArticle(data))
  }

  renderNews(data) {
    let title = '';
    if (!_.isEmpty(data.title)) {
      title = data.title.replace(/<[^>]+>/g, "")
    }
    return (
      <div>
        <a className='mlt-data-title' onClick={() => this.handleClickData(data)}>
          <span className="feed-tag feed-tag-primary margin-right-md">{t(data.mediaType)}</span>
          <Truncate title={title} className="item-display" html={data.title} />
        </a>
        <div className="mlt-data-footer">
          <span>{t('subjectMonitoringFeedFrom')} </span>
          <span>
            {data.from}
          </span>
          {data.mediaType !== "youtube" &&
            <span>
              <span> - </span>
              <span>
                {data.in}
              </span>
            </span>
          }
          <span> {t('subjectMonitoringFeedAt')} </span>
          <span>
            {moment(data.date).format('YYYY-MM-DD HH:mm')}
          </span>
        </div>
      </div>
    )
  }
  renderFacebook(data) {
    let title = '';
    if (!_.isEmpty(data.content)) {
      title = data.content.replace(/<[^>]+>/g, "")
    }
    return (
      <div>
        <a className='mlt-data-title' onClick={() => this.handleClickData(data)}>
          <span className="feed-tag feed-tag-primary margin-right-md">Facebook</span>
          <Truncate title={title} className="item-display" html={data.content} />
        </a>
        <div className="mlt-data-footer">
          <span>{t('subjectMonitoringFeedFrom')} </span>
          <span>
            {data.by}
          </span>
          <span> {t('subjectMonitoringFeedAt')} </span>
          <span>
            {moment(data.date).format('YYYY-MM-DD HH:mm')}
          </span>
        </div>
      </div>
    )
  }
  renderWeibo(data) {
    let title = '';
    if (!_.isEmpty(data.content)) {
      title = data.content.replace(/<[^>]+>/g, "")
    }
    return (
      <div>
        <a className='mlt-data-title' onClick={() => this.handleClickData(data)}>
          <span className="feed-tag feed-tag-primary margin-right-md">{t(data.mediaType)}</span>
          <Truncate title={title} className="item-display" html={data.content} />
        </a>
        <div className="mlt-data-footer">
          <span>{t('subjectMonitoringFeedFrom')} </span>
          <span>
            {data.by}
          </span>
          <span> {t('subjectMonitoringFeedAt')} </span>
          <span>
            {moment(data.date).format('YYYY-MM-DD HH:mm')}
          </span>
        </div>
      </div>
    )
  }
  renderWechat(data) {
    let title = '';
    if (!_.isEmpty(data.title)) {
      title = data.title.replace(/<[^>]+>/g, "")
    }
    return (
      <div>
        <a className='mlt-data-title' onClick={() => this.handleClickData(data)}>
          <span className="feed-tag feed-tag-primary margin-right-md">{t(data.mediaType)}</span>
          <Truncate title={title} className="item-display" html={data.title} />
        </a>
        <div className="mlt-data-footer">
          <span>{t('subjectMonitoringFeedFrom')} </span>
          <span>
            {data.from}
          </span>
          <span> {t('subjectMonitoringFeedAt')} </span>
          <span>
            {moment(data.date).format('YYYY-MM-DD HH:mm')}
          </span>
        </div>
      </div>
    )
  }
  renderTwitter(data) {
    let title = '';
    if (!_.isEmpty(data.content)) {
      title = data.content.replace(/<[^>]+>/g, "")
    }
    return (
      <div>
        <a className='mlt-data-title' onClick={() => this.handleClickData(data)}>
          <span className="feed-tag feed-tag-primary margin-right-md">Twitter</span>
          <Truncate title={title} className="item-display" style={{ width: "250px" }} html={data.content} />
        </a>
        <div className="mlt-data-footer">
          <span>{t('subjectMonitoringFeedFrom')} </span>
          <span>{data.by}</span>
          {data.in && <span> @ </span>}
          <span>{data.in}</span>
          <span> {t('subjectMonitoringFeedAt')} </span>
          <span>
            {moment(data.date).format('YYYY-MM-DD HH:mm')}
          </span>
        </div>
      </div>
    )
  }

  renderMltData = (data) => {
    switch (data.mediaType) {
      case 'youtube':
      case 'news':
        return this.renderNews(data);
        break;
      case 'forum':
      case 'forumComment':
        return this.renderNews(data);
        break;
      case 'blog':
        return this.renderNews(data);
        break;
      case 'video':
        return this.renderNews(data);
        break;
      case 'macautalk':
        return this.renderNews(data);
        break;
      case 'facebook':
        return this.renderFacebook(data);
        break;
      case 'pixnet':
      case 'wechat':
        return this.renderWechat(data);
        break;
      case 'weibo':
        return this.renderWeibo(data);
        break;
      case 'twitter':
        return this.renderTwitter(data);
        break;
    }
  }

  renderArticleData = (data) => {

    switch (data.mediaType) {
      case 'facebook':
      case 'twitter':
      case 'instagram':
        return this.renderFacebookArticle(data);
        break;
      case 'youtube':
        return this.renderYoutubeArticle(data);
        break;
      default:
        return this.renderArticle(data);
        break;
    }
  }

  renderYoutubeArticle = (data) => {
    const {
      clipping,
      loadingList
    } = this.props;
    const disabled = _.includes(clipping, data.globalId)
    let title = '';
    if (!_.isEmpty(data.content)) {
      title = data.content.replace(/<[^>]+>/g, "")
    }
    // let e =  data.content.replace(/"\r\nSourcePh</Source>\" style=\"display:none\">"/, "")
    return (
      <div>
        <div className="modal-title">
          <Truncate title={title} html={data.title} />
        </div>
        <div className="modal-body">
          <div className="margin-bottom-md clearfix">
            <div className="pull-left">
              <span>{t('subjectMonitoringFeedFrom')} </span>
              <span>{data.from} </span>
              <span>{moment(data.date).format('YYYY-MM-DD HH:mm')}</span>
            </div>
            <div className="pull-right model-right-icon">
              <Tooltip placement="bottom" title="收藏">
                {disabled &&
                  <Icon type="star" className="cursor-pointer star-active" onClick={() => this.handleRemoveCollection(data.globalId)} />
                  ||
                  <span>
                    {_.includes(loadingList, data.globalId) &&
                      <Tooltip placement="top" title="收藏中...">
                        <Icon type="loading" />
                      </Tooltip>
                      ||
                      <Icon type="star" className="cursor-pointer" onClick={() => this.handleAddCollection(data.globalId)} />
                    }
                  </span>
                }
              </Tooltip>
              <Tooltip placement="bottom" title="查看原文">
                <a className="margin-left-md" href={data.url} target="_blank"><Icon type="ie" /></a>
              </Tooltip>
            </div>
          </div>
          <div dangerouslySetInnerHTML={{ __html: data.content }} />
          <object style={{ width: "100%", height: "350px" }} data={data.url}></object>
        </div>
      </div>
    )
  }

  renderFacebookArticle = (data) => {
    const {
      clipping,
      loadingList
    } = this.props;
    const disabled = _.includes(clipping, data.globalId)
    return (
      <div>
        <div className="modal-body">
          <div className="margin-bottom-md clearfix">
            <div className="pull-left">
              <div className="article-avatar">
                <img
                  src={data.byImageUrl}
                  ref={(avatar) => {
                    if (avatar) {
                      avatar.onerror = () => {
                        avatar.src = avatarUrl;
                      }
                    }
                  }}
                />
              </div>
            </div>
            <div className="pull-left">
              <span>{t('subjectMonitoringFeedFrom')} </span>
              <span>{data.from} </span>
              <br />
              <span>{moment(data.date).format('YYYY-MM-DD HH:mm')}</span>
            </div>
            <div className="pull-right model-right-icon">
              <Tooltip placement="bottom" title="收藏">
                {disabled &&
                  <Icon type="star" className="cursor-pointer star-active" onClick={() => this.handleRemoveCollection(data.globalId)} />
                  ||
                  <span>
                    {_.includes(loadingList, data.globalId) &&
                      <Tooltip placement="top" title="收藏中...">
                        <Icon type="loading" />
                      </Tooltip>
                      ||
                      <Icon type="star" className="cursor-pointer" onClick={() => this.handleAddCollection(data.globalId)} />
                    }
                  </span>
                }
              </Tooltip>
              <Tooltip placement="bottom" title="查看原文">
                <a className="margin-left-md" href={data.url} target="_blank"><Icon type="ie" /></a>
              </Tooltip>
            </div>
          </div>
          <div dangerouslySetInnerHTML={{__html: data.content}} />
            <img className='picture' src={data.fullPicture} />
            {data.statusType === 'added_video' &&
              <Player
                  width = '90%'
                  height = '80%'
                  playsInline
                  src= {data.source}
              />
            }
            {!_.isEmpty(data.images) &&
              <div>
                {_.map(data.images, (img) => 
                  <img className='picture' src={img} />
                )}
              </div>
            }
        </div>
      </div>
    )
  }

  renderArticle = (data) => {
    const {
      clipping,
      loadingList
    } = this.props;
    const disabled = _.includes(clipping, data.globalId)
    let title = '';
    if (!_.isEmpty(data.title)) {
      title = data.title.replace(/<[^>]+>/g, "")
    }

    let pdfSrc = '';
    if (!_.isEmpty(data.pdfUrl)) {
      pdfSrc = `/pdfviewer/web/viewer.html?file=/file/${data.pdfUrl.replace('http://file-api.ersinfotech.com/', '')}`
    }
    let printPdfSrc = '';
    if (data.mediaType == 'print') {
      printPdfSrc = `/pdfviewer/web/viewer.html?file=${data.url}`
    }
    let content = data.content;
    if (!_.isEmpty(content)) {
      content = content.replace(/data-src/g, 'src')
      content = content.replace(/http:\/\/mmbiz.qpic.cn\//g, `${config.microdata.baseUrl}/imgserve?_url=http://mmbiz.qpic.cn/`)
      if (data.from == "批踢踢實業坊") {
        content = content.replace(/\n/g, '<br />')
      }
      content = content.replace("\r\nSourcePh</Source>\" style=\"display:none\">", '')
      content = content.replace('rich_media_title','hiddenRC')
      content = content.replace('rich_media_meta_list','hiddenRC')
    }


    return (
      <div>
        <div className="modal-title">
          <Truncate title={title} html={data.title} />
        </div>
        <div className="modal-body">
          <div className="margin-bottom-md clearfix">
            <div className="pull-left">
              <span>{t('subjectMonitoringFeedFrom')} </span>
              <span>{data.from}</span>
              <span>-</span>
              <span>{data.in}</span>
              <span>{moment(data.date).format('YYYY-MM-DD HH:mm')}</span>
            </div>
            <div className="pull-right model-right-icon">
              <Tooltip placement="bottom" title="收藏">
                {disabled &&
                  <Icon type="star" className="cursor-pointer star-active" onClick={() => this.handleRemoveCollection(data.globalId)} />
                  ||
                  <span>
                    {_.includes(loadingList, data.globalId) &&
                      <Tooltip placement="top" title="收藏中...">
                        <Icon type="loading" />
                      </Tooltip>
                      ||
                      <Icon type="star" className="cursor-pointer" onClick={() => this.handleAddCollection(data.globalId)} />
                    }
                  </span>
                }
              </Tooltip>
              <Tooltip placement="bottom" title="查看原文">
                <a className="margin-left-md" href={data.url} target="_blank"><Icon type="ie" /></a>
              </Tooltip>
            </div>
          </div>
          {data.mediaType == 'video' &&
            <div>
              {this.matchTDM(data) &&
                <div ref="video" id="video" />
              || _.get(data, 'videoUrl', '').match(/youtube/) &&
                <Player width='100%' height='90%'>
                  <source src={data.videoUrl} />
                </Player>
              || _.get(data, 'videoUrl', '').match(/\.mp4$/) &&
                <Player width='100%' height='90%'>
                  <source src={data.videoUrl} />
                </Player>
              }
            </div>
          }
          {!_.isEmpty(data.pdfUrl) &&
            <iframe src={pdfSrc}></iframe>
            ||
            <div dangerouslySetInnerHTML={{ __html: content }} />

          }
          {data.mediaType == 'print' &&
            <iframe src={printPdfSrc}></iframe>
          }
        </div>
      </div>
    )
  }

  renderComment = (data) => {
    return (
      <div className="comment-item">
        <div className="comment-content">
          <div dangerouslySetInnerHTML={{ __html: data.content }} />
        </div>
        <div className="mlt-data-footer margin-bottom-sm clearfix">
          <div className="pull-left">
            <span>{data.by} </span>
            <span>{t('subjectMonitoringFeedAt')}</span>
            <span> {moment(data.date).format('YYYY-MM-DD HH:mm')}</span>
          </div>
          <div className="pull-right">
            #{data.position}
          </div>
        </div>
      </div>
    )
  }

  handleRemoveCollection = (globalId) => {
    const { dispatch, userId } = this.props;
    // dispatch(deleteCollection({
    //   globalId: [globalId],
    //   userId: userId,
    // }))
    dispatch(setCollection({
      type: 'DELETE',
      globalId: [globalId],
      userId: userId
    }))
      .then(() => {
        const { register_email } = localStorage;
        logAsync({
          type: "sPOP-remove-collection",
          data: {
            globalId: globalIds,
            user: register_email
          }
        })
      })
  }

  handleAddCollection = (globalId) => {
    const {
      dispatch,
      permission,
      clipping,
      userId
    } = this.props;
    if (_.get(clipping, 'length', 0) < _.get(permission, 'limit')) {
      dispatch(setCollection({
        type: 'ADD',
        globalId: [globalId],
        userId: userId
      }))
      .then(() => {
        const {register_email} = localStorage;
        logAsync({
          type: 'sPOP-add-collection',
          data: {
            globalIds: [globalId],
            user: register_email
          }
        })
        notification.showClippingSuccess();
      })
      .catch(()=>{
        notification.error(t('commonClippingFail'));
      });
    } else {
      notification.showClippingFull();
    }
  };

  showTotal = (total) => {
    return t('commonShowTotal', {
      total: total
    });
  }

  render() {
    const {
      isOpen,
      data,
      mltData,
      commentData
    } = this.props.articleModal;
    const comments = ['forum', 'facebook', 'goods', 'page']

    return (
      <div>
        <Modal
          isOpen={isOpen}
          closeTimeoutMS={150}
          style={styles}
          onRequestClose={() => this.handleModalState(data)}
        >
          <button className="pull-right margin-right-md model-close-button" onClick={() => this.handleModalState(data)}><Icon type="cross" /></button>
          <Scrollbars autoHide={true} style={{ zIndex: 1 }}>
            <div className="padding-lg">
              <Row>
                <Col span='14' className="padding-right-md">
                  {this.renderArticleData(data)}
                  <div>
                    {_.includes(comments, data.mediaType) &&
                      <div>
                        <div className="modal-title">
                          <span>{t('commonComment')}</span>
                        </div>
                        {commentData.isLoading &&
                          <div className="text-center"><Spin /></div>
                        }
                        {
                          _.map(_.get(commentData, 'data.data'), (comment, i) => {
                            return (
                              <div key={i}>
                                {this.renderComment(comment)}
                              </div>
                            )
                          })
                        }
                        {_.get(commentData, 'data.count') === 0 &&
                          <div className="undefinedText">
                            {t('commonNoData')}
                          </div>
                          ||
                          <Pagination className="pull-right padding-md" pageSize={5} current={this.state.current} total={_.get(commentData, 'data.count')} showTotal={this.showTotal} onChange={this.onPageChange} />
                        }
                      </div>
                    }
                  </div>
                </Col>
                <Col span="10" className="padding-left-lg">
                  <div className="modal-title">
                    <span>{t('commonMLT')}</span>
                  </div>
                  <div>
                    {mltData.isLoading &&
                      <div className="text-center"><Spin /></div>
                    }
                    {_.get(mltData, 'data.count') === 0 &&
                      <div className="undefinedText">
                        {t('commonNoMlt')}
                      </div>
                    }
                    {data.globalId == null &&
                      <div className="undefinedText">
                        {t('commonNoMlt')}
                      </div>
                    }
                    {_.map(_.get(mltData, 'data.data'), (mlt, i) => {
                      return (
                        <div key={i} className="padding-top-md">
                          <div>{this.renderMltData(mlt)}</div>
                        </div>
                      )
                    })
                    }
                  </div>
                </Col>
              </Row>
            </div>
          </Scrollbars>
        </Modal>
      </div>
    );
  }
}

export default container(ArticleModal)



/** WEBPACK FOOTER **
 ** ./src/app/modules/modal/components/ArticleModal.js
 **/